import { isCustomizedType, reduce } from "et3-type-guards";

import { Ti18nKeys } from "../../constants/i18n";
import i18nServerResponse from "../../constants/i18n-server-response";
import { TBWTypes, TCorePage } from "../../Types";
import { post } from "../axios-post";

export const apiCallAddUserToInvestigation = async ({
  adminId,
  userUUID,
  pageName,
  actionName,
  actionID,
  TBW_ids,
  temporaryBanDays
}: {
  adminId: number;
  userUUID: string;
  pageName: TCorePage;
  actionName: TBWTypes;
  actionID: number;
  TBW_ids: number[];
  temporaryBanDays: number;
}): Promise<{
  data: string;
  status: string;
  code: Ti18nKeys;
}> => {
  const { status, data, et3Error } = await post(`user/addUserToInvestigation`, {
    adminId,
    userUUID,
    pageName,
    actionName,
    actionID,
    TBW_ids,
    temporaryBanDays
  });

  if (
    status === "OK" &&
    !isCustomizedType<{
      errorCode: string;
      et3Message: string;
    }>(
      {
        errorCode: "ERROR",
        et3Message: "ERROR"
      },
      data
    )
  ) {
    return {
      data: "",
      status: "OK",
      code: "SUCCESS"
    };
  } else if (status === "ERROR") {
    const errorNumber = reduce(() => et3Error.errorNumber, 0);
    return {
      data: "",
      status: "ERROR",
      code: i18nServerResponse.get(errorNumber)
    };
  } else {
    return {
      data: "",
      status: "ERROR",
      code: "ERROR"
    };
  }
};
